import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isLoading, load } from '../reducers/meetingLandingPage';

import HorseRacingMeetingLandingPageList from '../components/HorseRacingMeetingLandingPageList';

const REFRESH_INTERVAL_MILLIS = 10000;

@standardAsyncConnect([
  {
    dispatch: ({params: { meetingId }}) => load(meetingId),
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => ({fastResults: state.horseRacing.meetingLandingPage.meeting})
  }
])
@catchLifeCycleErrors
export default class HorseRacingMeetingLandingContainer extends Component {
  static propTypes = {
    routes: PropTypes.array,
    fastResults: PropTypes.object
  };

  render() {
    const {
      routes,
      fastResults: {
        meeting_summary: meeting,
        fast_results: results
      } = {}
    } = this.props;

    return <HorseRacingMeetingLandingPageList {...{results, meeting, routes}}/>;
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingMeetingLandingContainer.js